import router from "@/router";
/**前往登录、注册、找回密码 */
export const goLogin = () => {
  const clientType = "CDN";
  if (process.env.NODE_ENV == "production") {
    //线上
    const targetUrl = window.location.href;
    window.location.href =
      "https://www.ringdata.com/user-center/login/" +
      clientType +
      "/" +
      encodeURIComponent(targetUrl);
  } else {
    // 开发;
    router.push("/login");
  }
};

export const goRegister = () => {
  const clientType = "CDN";
  const targetUrl = window.location.href;
  const href =
    "https://www.ringdata.com/user-center/register/" +
    clientType +
    "/" +
    encodeURIComponent(targetUrl);
  window.open(href, "_blank", "noopener,noreferrer");
};

export const goFindPassword = () => {
  const clientType = "CDN";
  const targetUrl = window.location.href;
  const href =
    "https://www.ringdata.com/user-center/find-password/" +
    clientType +
    "/" +
    encodeURIComponent(targetUrl);
  window.open(href, "_blank", "noopener,noreferrer");
};
